import { AuthContext } from 'context/authContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { ErrorToast, SuccessToast } from 'services/toasterService';

export default function useUpdateAdminProfile() {
  const queryClient = useQueryClient();

  const { authDispatch } = useContext(AuthContext);

  return useMutation(
    async (data) => {
      const response = await makeApiRequest.put(
        apiEndPoints.ADMIN_PROFILE,
        data
      );
      return response?.data;
    },
    {
      onSuccess: (data) => {
        authDispatch({
          type: 'UPDATE_PROFILE_NAME',
          payload: data?.data?.[0]?.first_name
        })
        SuccessToast({ text: data.message });
        queryClient.invalidateQueries('get-admin-profile-details');
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
